import { createContext, PropsWithChildren, useContext, useMemo } from 'react';

export interface RadioListContext {
  compacted?: boolean;
}

const Context = createContext<RadioListContext>(null);

interface RadioListProviderProps {
  compacted?: boolean;
}

export const RadioListProvider = ({ compacted, children }: PropsWithChildren<RadioListProviderProps>) => {
  const context = useMemo(
    () => ({
      compacted,
    }),
    [compacted],
  );

  return <Context.Provider value={context}>{children}</Context.Provider>;
};

export const useRadioList = () => {
  const context = useContext(Context);
  if (!context) {
    throw Error('useRadioList must be used within a RadioListProvider');
  }

  return context;
};
